import { render, staticRenderFns } from "./UnauthorisedAccessApprove.vue?vue&type=template&id=6db8ef1e"
import script from "./UnauthorisedAccessApprove.vue?vue&type=script&lang=js"
export * from "./UnauthorisedAccessApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports